<template>
  <div class="panel panel-default panel-dashboard">
    <div v-if="!loading" class="panel-body">
      <form @submit.prevent="submit" style="margin-bottom: 22px">
        <div class="row">
          <div class="col-sm-12">
            <input type="search" v-model="actualListFilters.search" class="form-control" placeholder="Search...">
          </div>

          <div class="col-sm-6">
            <select-widget
                v-model="actualListFilters.status"
                :nullable="true"
                :options="[{value: 'open', label: 'Open'}, {value: 'missed', label: 'Missed'}, {value: 'converted', label: 'Converted'}]"
                placeholder="(all statuses)"
            />
          </div>

          <div class="col-sm-6">
            <button type="submit" class="btn btn-grey btn-block">
              <i class="fa fa-filter"></i> Filter
            </button>
          </div>
        </div>
      </form>

      <table class="table table-striped table-condensed">
        <thead>
        <tr>
          <th class="col-xs-1 text-center">
            <input
                type="checkbox"
                v-model="selectAll"
                :indeterminate.prop="selected.length && selected.length !== opportunities.length"
            >
          </th>

          <th class="col-xs-3">
            <a href="#" @click.prevent="sort('title')">
              Title <i class="fa fa-sort"></i>
            </a>
          </th>

          <th class="col-xs-3">
            Company
          </th>

          <th class="col-xs-3">
            User
          </th>

          <th class="col-xs-3">
            Portal
          </th>

          <th class="col-xs-2">
            <a href="#" @click.prevent="sort('value')">
              Value <i class="fa fa-sort"></i>
            </a>
          </th>

          <th class="col-xs-3">
            <a href="#" @click.prevent="sort('conversion_expected_at')">
              Expected At <i class="fa fa-sort"></i>
            </a>
          </th>

          <th class="col-xs-5">
            Attributes
          </th>

          <th class="col-xs-1"></th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="opportunity in opportunities">
          <td class="text-center">
            <input
                type="checkbox"
                v-model="selected"
                :value="opportunity"
            >
          </td>

          <td class="table__ellipsis">
            <router-link :to="getUrl(opportunity)">
              {{ opportunity.attributes.title }}
            </router-link>
          </td>

          <td class="table__ellipsis">
            <router-link :to="'/companies/' + opportunity.attributes.company_id">
              {{ opportunity.attributes.company_name }}
            </router-link>
          </td>

          <td class="table__ellipsis">
            <router-link :to="'/users/' + opportunity.attributes.user_id + '/edit'">
              {{ opportunity.attributes.user_full_name }}
            </router-link>
          </td>

          <td class="table__ellipsis">
            <router-link :to="'/portals/' + opportunity.attributes.portal_id">
              {{ opportunity.attributes.portal_name }}
            </router-link>
          </td>

          <td>
            {{ opportunity.attributes.value | price }}
          </td>

          <td>
            {{ opportunity.attributes.conversion_expected_at | date }}
          </td>

          <td>
            <span v-if="opportunity.attributes.category === 'advertising'" class="label label-info">Advertising</span>

            <span v-if="opportunity.attributes.category === 'subscription'" class="label label-default">Subscription</span>

            <span v-if="opportunity.attributes.is_new_business === true"
                  class="label label-success">New</span>

            <span v-if="opportunity.attributes.is_new_business === false" class="label label-warning">Existing</span>

            <span v-if="opportunity.attributes.is_new_business === null"
                  class="label label-info">Unknown</span>

            <span v-if="opportunity.attributes.status === 'converted'"
                  class="label label-success">Converted</span>

            <span v-if="opportunity.attributes.status === 'open'" class="label label-warning">Open</span>

            <span v-if="opportunity.attributes.status === 'missed'" class="label label-danger">Missed</span>
          </td>

          <td class="text-right">
            <div class="btn-group list-actions">
              <router-link :to="getUrl(opportunity)" class="btn btn-sm">
                <i class="fa fa-search"></i>
              </router-link>

              <button
                  type="button"
                  class="btn btn-sm"
                  @click="destroy(opportunity)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="row">
        <div class="col-xs-6">
          <div class="dropup">
            <button
                class="btn btn-info btn-sm dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                :disabled="!selected.length"
            >
              <i class="fa fa-cogs"></i> List Actions <span class="caret"></span>
            </button>

            <ul class="dropdown-menu">
              <li>
                <a href="#" @click.prevent="destroySelected">
                  <i class="fa fa-trash"/> Delete selected
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-xs-12">
          <resource-pager
              class="table__pager"
              v-if="pagination.last_page > 1"
              :pagination="pagination"
              @navigate="$emit('navigate', page = $event)"
          />
        </div>

        <div class="col-xs-6 text-right">
          <button class="btn btn-info btn-sm" type="button" :disabled="!opportunities.length" @click="download">
            <i class="fa fa-download"/> Export
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import download from 'downloadjs'
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import store from '@/store'
import ResourcePager from '@/components/Utilities/Pagination/ResourcePager'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'

export default {
  components: {ResourcePager, SelectWidget},

  props: {
    filters: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      opportunities: [],
      pagination: null,

      listFilters: {},
      actualListFilters: {},

      sortColumn: 'conversion_expected_at',
      sortDirection: 'asc',

      editing: null,

      loading: true,
      selected: [],
      selectAll: false,
      page: 1,

      shared: store
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    page() {
      this.load()
    },

    filters: {
      deep: true,
      handler: function () {
        this.navigate(1)
      }
    },

    selected() {
      if (this.selected.length === this.opportunities.length) {
        this.selectAll = true
      }

      if (this.selected.length === 0) {
        this.selectAll = false
      }
    },

    selectAll(value) {
      this.selected = value ? this.opportunities : []
    }
  },

  computed: {
    requestParameters() {
      let parameters = Object.entries(this.filters)
          .concat(Object.entries(this.listFilters))
          .reduce((filters, filter) => {
            if (!filter[1]) {
              return filters
            }

            filters['filter[' + filter[0] + ']'] = filter[1]

            return filters
          }, {})

      parameters.page_size = 10

      parameters.page = this.page

      parameters.sort = this.sortColumn ? (this.sortDirection === 'desc' ? '-' : '') + this.sortColumn +",id" : "id"

      return parameters
    }
  },

  methods: {
    load() {
      this.selected = []

      http.get('/api/v2/opportunities', this.requestParameters).then(response => {
        this.opportunities = response.data.data

        this.pagination = response.data.meta

        this.loading = false
      })
    },

    destroy(opportunity) {
      modal.confirm('Are you sure that you want to delete the opportunity?', () => {
        this.getDestroyPromise(opportunity).then(() => {
          notify.success('The opportunity was deleted')

          this.load()
        })
      })
    },

    destroySelected() {
      modal.confirm('Are you sure that you want to delete the opportunities?', () => {
        Promise.all(this.selected.map(opportunity => this.getDestroyPromise(opportunity))).then(() => {
          notify.success('The opportunities were deleted')

          this.load()
        })
      })
    },

    getDestroyPromise(opportunity) {
      return http.delete('/api/v2/opportunities/' + opportunity.id)
    },

    update(opportunity) {
      let index = this.opportunities.findIndex(existing => existing.id === opportunity.id)

      if (index > -1) {
        this.opportunities.splice(index, 1, opportunity)
      }
    },

    sort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortDirection = 'desc'
      }

      this.sortColumn = column

      this.navigate(1)
    },

    navigate(page) {
      this.page = page

      this.load()
    },

    submit() {
      this.listFilters = this.actualListFilters

      this.navigate(1)
    },

    getUrl(opportunity) {
      return '/companies/' + opportunity.attributes.company_id + '/opportunities/' + opportunity.id
    },

    download() {
      axios.post(
          '/api/v1/reports/opportunity-index',
          {filters: {...this.filters, ...this.listFilters}},
          {
            headers: {
              'Authorization': 'Bearer ' + this.shared.token
            },
            responseType: 'blob'
          }
      ).then(response => {
        download(response.data, response.headers['content-disposition'].slice(22, -1))
      })
    }
  }
}
</script>
